import e from "./index48.js";
import t from "./index46.js";
import "./index47.js";
class s extends e {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(a) {
    super.updateOptions(a);
  }
  _update(a) {
    super._update({
      ...a,
      validate: a.mask
    });
  }
}
t.MaskedFunction = s;
export {
  s as default
};
